import styled from 'styled-components';
import {tokens} from '@tickchak/react-share/app';
import {
    dFlex, dFlexColumn, flexWrap, flexRow,
    alignCenter, alignEnd, justifyCenter, justifyEnd
} from '../../../../../../../globalVariables/GlobalFlex';

export {dot} from '../../timetableSales.css';

export const figures = styled.div`
  ${dFlex}
  ${flexWrap}
  ${alignCenter}
  ${justifyEnd}
  container-type: inline-size;
  align-self: stretch;
  gap: var(--space-md);
`;
export const figure = styled.div`
  ${dFlexColumn}
  ${alignEnd}
  ${justifyCenter}
  flex: 1 1 0;
`;
export const figureDivider = styled.div`
  width: 1px;
  height: 19px;
  align-self: center;
  background: var(--TA-color-border-subtle);
  @container (max-width: 380px){ display: none; }
`;
export const figureVal = styled.div`
  font-size: ${tokens.typography.fontSize.body};
  font-weight: ${tokens.typography.fontWeight.regular};
  line-height: 20px;
  white-space: nowrap;
`;
export const figureLabel = styled.div`
  ${dFlex}
  ${flexRow}
  ${alignCenter}
  direction: ${p => p.theme.rtl ? 'rtl' : 'ltr'};
  gap: var(--space-sm);
  font-size: ${tokens.typography.fontSize.bodySmall};
  line-height: 20.5px;
  white-space: nowrap;
`;
